<header class="modern-navbar">
  <!-- Top Bar avec Informations de Contact -->
  <div class="top-bar">
      <div class="container">
          <div class="row align-items-center">
              <div class="col-lg-8 col-md-12">
                  <div class="contact-info">
                      <div class="contact-item">
                          <i class="icofont-location-pin"></i>
                          <span>
                              <strong>Guinée - Conakry</strong>
                              <br/>
                              {{ appSettingService.value.address }}
                          </span>
                      </div>
                      <div class="contact-item">
                          <i class="icofont-phone"></i>
                          <span>
                              <strong>+224 {{ appSettingService.value.phone_number2 }}</strong>
                              <br/>
                              Appelez-nous
                          </span>
                      </div>
                      <div class="contact-item">
                          <i class="icofont-email"></i>
                          <span>
                              <strong>{{ appSettingService.value.email }}</strong>
                              <br/>
                              Contactez-nous
                          </span>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4 col-md-12">
                  <div class="top-actions">
                      <div class="social-links">
                          <a [href]="appSettingService.value.facebook_url" title="Facebook" target="_blank" class="social-link">
                              <i class="icofont-facebook"></i>
                          </a>
                          <a [href]="appSettingService.value.youtube_url" title="Youtube" target="_blank" class="social-link">
                              <i class="icofont-youtube-play"></i>
                          </a>
                          <a [href]="appSettingService.value.twiter_url" title="Twitter" target="_blank" class="social-link">
                              <i class="icofont-twitter"></i>
                          </a>
                          <a [href]="appSettingService.value.instagram_url" title="Instagram" target="_blank" class="social-link">
                              <i class="icofont-instagram"></i>
                          </a>
                      </div>
                      <div class="auth-buttons">
                          <button (click)="authService.logout()" class="btn-register">
                            <i class="icofont-logout"></i>
                            Déconnexion
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

  <!-- Main Navigation -->
  <nav class="main-navbar">
      <div class="container">
          <div class="navbar-wrapper">
              <!-- Logo -->
              <div class="navbar-brand">
                  <a routerLink="/" class="logo-link">
                      <img [src]="appSettingService.value.logo" alt="BSTP Logo" class="logo-img">
                  </a>
              </div>

              <!-- Mobile Menu Toggle -->
              <div class="mobile-toggle" (click)="toggleMobileMenu()">
                  <span></span>
                  <span></span>
                  <span></span>
              </div>

              <!-- Navigation Menu -->
              <div class="navbar-menu" [class.active]="isMobileMenuOpen">
                  <ul class="nav-menu">
                      <li class="nav-item">
                          <a routerLink="/evaluator/dashboard" 
                             class="nav-link" 
                             routerLinkActive="active"
                             [routerLinkActiveOptions]="{ exact: true }"
                             (click)="closeMobileMenu()">
                              TABLEAU DE BORD
                          </a>
                      </li>

                      <li class="nav-item">
                          <a routerLink="/evaluator/campagnes" 
                             class="nav-link" 
                             routerLinkActive="active"
                             [routerLinkActiveOptions]="{ exact: true }"
                             (click)="closeMobileMenu()">
                              GESTION DES RESPONSES
                          </a>
                      </li>
                      <li class="nav-item">
                          <a routerLink="/evaluator/companies" 
                             class="nav-link" 
                             routerLinkActive="active"
                             [routerLinkActiveOptions]="{ exact: true }"
                             (click)="closeMobileMenu()">
                              GESTION DES ENTREPRISES
                          </a>
                      </li>

                      <li class="nav-item">
                            <a routerLink="/evaluator/account" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                MON COMPTE
                            </a>
                        </li>

                  </ul>
              </div>
          </div>
      </div>
  </nav>
</header>
